import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import Header from "../../components/header";
import check from "../../dbt_assets/images/check.svg";
import heroImage from "../../assets/images/pngs/hero-image.svg";
import { stats } from "./data";

const datamatesDevPoints = [
  "AI teammates that understand your data ecosystem and standards",
  "Enhanced Cursor, GitHub Copilot, and other AI coding tools with data awareness",
  "Organizational knowledge and memory built into your coding workflow",
  "PII guardrails ensure enterprise-grade data safety",
];

export const DatamatesHeader = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [phraseVisible, setPhraseVisible] = useState(true);
  
  const phrases = ["for you!", "with you!", "like you!"];

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setPhraseVisible(false);
      
      setTimeout(() => {
        setCurrentPhraseIndex((prevIndex) => (prevIndex + 1) % phrases.length);
        setPhraseVisible(true);
      }, 300); // Half of transition duration for smooth fade out/in
    }, 2000); // Change phrase every 2 seconds

    return () => clearInterval(interval);
  }, [phrases.length]);

  return (
    <div className="relative overflow-hidden bg-gradient-to-b from-[#f8fafc] to-white">
      <div className="absolute inset-0 grid-pattern opacity-50"></div>
      
      <div className="relative custom-container">
        <Header />
        
        <div className="flex flex-col items-center text-center px-4 pt-[100px] md:pt-[140px] pb-[60px] md:pb-[80px]">
          {/* Main headline with animation */}
          <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h1 className="text-[#082247] text-[40px] md:text-[64px] lg:text-[72px] font-bold leading-[1.1] max-w-[900px] mx-auto mb-6">
              <span className="block">AI teammates that work</span>
              <span 
                className={`bg-gradient-to-r from-[#3f8cff] to-[#8b5cf6] bg-clip-text text-transparent transition-all duration-600 inline-block min-h-[1.2em] ${
                  phraseVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2'
                }`}
                style={{ minWidth: '200px' }}
              >
                {phrases[currentPhraseIndex]}
              </span>
            </h1>
            
            <p className="text-[#5e7493] text-lg md:text-xl lg:text-2xl font-normal max-w-[700px] mx-auto mb-10 leading-relaxed">
              Transform your data workflows with AI teammates that know your business context, learn from your team, and protect sensitive data with enterprise guardrails.
            </p>
            
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <a 
                href="https://app.myaltimate.com/register" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <button className="px-8 py-4 bg-[#3f8cff] hover:bg-[#2d7df7] transition-all text-white text-lg font-medium rounded-xl shadow-lg shadow-blue-500/25 hover:shadow-xl hover:shadow-blue-500/30 hover:scale-[1.02]">
                  Start for free
                </button>
              </a>
              <a 
                href="https://calendly.com/d/cncb-mfh-wpq/demo-request-platform-cost-savings" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <button className="px-8 py-4 bg-white hover:bg-gray-50 transition-all text-[#082247] text-lg font-medium rounded-xl border border-gray-200 hover:border-gray-300 hover:scale-[1.02]">
                  Book a demo
                </button>
              </a>
            </div>
          </div>

          {/* Hero Image with floating animation */}
          <div className={`relative w-full max-w-[1200px] mx-auto transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-white p-2 md:p-4">
              <img 
                src={heroImage} 
                alt="DataMates AI Interface" 
                className="w-full h-auto rounded-lg"
              />
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-gradient-to-br from-[#3f8cff] to-[#8b5cf6] rounded-full blur-3xl opacity-40"></div>
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-gradient-to-br from-[#10b981] to-[#3f8cff] rounded-full blur-3xl opacity-40"></div>
            </div>
          </div>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pb-[60px] md:pb-[100px] px-4">
          {stats.map((stat, index) => (
            <div 
              key={index} 
              className={`text-center transition-all duration-700 delay-${index * 100} ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
            >
              <div className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#082247] mb-2">
                {stat.number}
              </div>
              <div className="text-sm md:text-base text-[#5e7493]">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}; 